import { z } from 'zod';

export const FinancialCategorySchema = z.object({
  id: z.string(),
  name: z.string(),
  type: z.enum(['income', 'expense']),
  color: z.string(),
  icon: z.string(),
  description: z.string().optional(),
  isActive: z.boolean(),
  order: z.number(),
});

export const FinancialRecordSchema = z.object({
  id: z.string(),
  title: z.string(),
  description: z.string().optional(),
  type: z.enum(['income', 'expense']),
  categoryId: z.string(),
  categoryName: z.string(),
  category: z.string().optional(), // Legacy alias
  tripId: z.string().optional(),
  clientId: z.string().optional(),
  budgetId: z.string().optional(),
  linkedEntityId: z.string().optional(),
  amount: z.number(),
  tax: z.number().optional(),
  totalAmount: z.number(),
  dueDate: z.union([z.date(), z.string()]),
  paymentDate: z.union([z.date(), z.string()]).optional(),
  paidDate: z.string().optional(), // Alias
  issueDate: z.union([z.date(), z.string()]),
  paymentStatus: z.enum(['pending', 'paid', 'overdue', 'partial']),
  status: z.enum(['pending', 'paid', 'overdue', 'partial']).optional(), // Legacy alias
  isRecurring: z.boolean(),
  recurrence: z.enum(['weekly', 'monthly', 'quarterly', 'yearly']).optional(),
  receiptUrl: z.string().optional(),
  invoiceUrl: z.string().optional(),
  createdAt: z.union([z.date(), z.string()]),
  updatedAt: z.union([z.date(), z.string()]),
  createdBy: z.string(),
  tags: z.array(z.string()).optional(),
  metadata: z.record(z.string(), z.any()).optional(),
}).passthrough();

export type FinancialRecord = z.infer<typeof FinancialRecordSchema>;
